
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefanalysis/privacy-policy",
      function () {
        return require("private-next-pages/debtreliefanalysis/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debtreliefanalysis/privacy-policy"])
      });
    }
  